import {useRef, useState} from 'react';

import {Box, ButtonBase, ClickAwayListener, Popper, Stack, Typography} from '@mui/material';

const C = {
    ink: 'var(--cg-text)',
    border: 'var(--cg-border)',
    surface: 'var(--cg-surface)',
    surfaceRaised: 'var(--cg-surface-raised)',
    textSoft: 'var(--cg-text-soft)',
    textMuted: 'var(--cg-text-muted)',
    shadow: 'var(--cg-shadow)',
    teal: '#1D9E75',
    tealL: '#E1F5EE',
    purple: '#534AB7',
    purpleL: '#EEEDFE',
};

const MENU_ITEMS = [
    {label: 'All listings — XLSX', format: 'xlsx', scope: 'all'},
    {label: 'All listings — CSV', format: 'csv', scope: 'all'},
    {label: 'Approved only — XLSX', format: 'xlsx', scope: 'approved', color: C.purple},
    {label: 'Approved only — CSV', format: 'csv', scope: 'approved', color: C.purple},
];

export default function ExportMenu({onExport, label = 'Export', items = MENU_ITEMS, sx = {}}) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    return (
        <Box sx={{padding: '12px', borderTop: `1px solid ${C.border}`, ...sx}}>
            <ButtonBase
                ref={anchorRef}
                onClick={() => setOpen((v) => !v)}
                sx={{
                    width: '100%',
                    border: `1px solid ${C.border}`,
                    background: C.surfaceRaised,
                    color: C.ink,
                    borderRadius: '10px',
                    padding: '9px 12px',
                    fontFamily: 'inherit',
                    fontWeight: 700,
                    fontSize: 13,
                    cursor: 'pointer',
                }}>
                {label}
            </ButtonBase>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="top-start"
                style={{zIndex: 1300}}
                modifiers={[{name: 'offset', options: {offset: [0, 6]}}]}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                    <Stack
                        sx={{
                            background: C.surface,
                            border: `1px solid ${C.border}`,
                            borderRadius: '10px',
                            boxShadow: `0 4px 16px ${C.shadow}`,
                            padding: '4px',
                            minWidth: 200,
                        }}>
                        {items.map((item) => (
                            <ButtonBase
                                key={`${item.format}-${item.scope}`}
                                onClick={() => {
                                    onExport(item.format, item.scope);
                                    setOpen(false);
                                }}
                                sx={{
                                    justifyContent: 'flex-start',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    fontFamily: 'inherit',
                                    fontSize: 12.5,
                                    fontWeight: 600,
                                    color: item.color || C.ink,
                                    cursor: 'pointer',
                                    '&:hover': {background: item.color ? `${item.color}11` : `${C.teal}11`},
                                }}>
                                <Stack direction="row" alignItems="center" gap="8px" sx={{width: '100%'}}>
                                    <Typography sx={{fontSize: 12.5, fontWeight: 600, color: 'inherit'}}>
                                        {item.label}
                                    </Typography>
                                </Stack>
                            </ButtonBase>
                        ))}
                    </Stack>
                </ClickAwayListener>
            </Popper>
        </Box>
    );
}
